import { apiRequest } from "../apiRequest";
import { roles } from "../../../config/constants";

export async function checkIfAdmin(userId, token) {

    let isAdmin = false;

    const userData = await apiRequest('get', null, `/user/profile/${userId}`, token, null, {}, true);

    if (userData && userData.data && userData.data.roles && userData.data.roles.includes(roles.admin)) {
        isAdmin = true;
    }

    return isAdmin;

}